import { getCarData } from 'app/services/businessFunctionHelpers';
import { BusinessFunctionsService } from 'app/services/businessFunctions.service';

export const setupInsuranceHistoryVisibility = () => {
  const coownersCount = getCarData().coownersCount;

  BusinessFunctionsService.setOwnerHistoryVisibilityBasedOnPersonalData();

  if (coownersCount === '1' || coownersCount === '2_') {
    BusinessFunctionsService.setFirstCoownerHistoryVisibilityBasedOnPersonalData();
  }

  if (coownersCount === '2_') {
    BusinessFunctionsService.setSecondCoownerHistoryVisibilityBasedOnPersonalData();
  }
};
